import React from "react";
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from "single-spa-react";
import rootComponent from "./app";
import { multiMounter } from '../../multiMounter';
import pkg from '../package.json';

export const { bootstrap, mount, unmount } = multiMounter('recommended-spare-parts',(el) => singleSpaReact({
    React,
    ReactDOMClient: {
        ...ReactDOMClient,
        createRoot: (container: ReactDOMClient.Container, options?: ReactDOMClient.RootOptions) => {
            return ReactDOMClient.createRoot(container, {
                ...options,
                identifierPrefix: `${pkg.name}-`,
            });
        },
    },
    rootComponent,
    renderType: "createRoot",
    domElementGetter: () => el,
    errorBoundary(err, info, props) {
        return <div>An unhandled frontend error occurred</div>;
    },
}));
